module.exports = __webpack_public_path__ + "img/nav-vehicle-models-homepage-mitsu.0bffdd3f.png";